<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px;">
  <div></div>
  <div style="display: flex; flex-direction: row; gap: 20px;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
          <mat-card-title>Edit Case</mat-card-title>
        </div>
      </mat-toolbar>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined">
          <mat-card-content style="margin-bottom: 0px; display: flex; flex-direction: row;">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 20px;">
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <div>
                  <div>
                    <mat-label class="title">Case Name</mat-label>
                  </div>
                  <div style="margin-top: 10px;">{{case.caseName}}</div>
                </div>
              </div>
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <div>
                  <div>
                    <mat-label class="title">Simple Case Id</mat-label>
                  </div>
                  <div style="margin-top: 10px;">{{case.simpleCaseId}}</div>
                </div>
              </div>
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <div>
                  <div>
                    <mat-label class="title">Date Created</mat-label>
                  </div>
                  <div style="margin-top: 10px;">{{case.dateTimeCreated | date: 'MM/dd/yyyy h:mm a'}}</div>
                </div>
              </div>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 20px;" *ngIf="users$ | async as users">
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <div style="display: flex; justify-content: flex-start;">
                    <mat-label class="title">User Access</mat-label>
                  </div>
                  <div style="display: flex; justify-content: flex-end;">
                    <div>
                      <a class="link" (click)="selectAllAccess(users)">All</a>
                    </div>
                    <div>
                      <a class="link" (click)="removeAllAccess()">None</a>
                    </div>
                  </div>
                </div>
                <mat-selection-list class="list" [(ngModel)]="userIds" style="text-align: left;">
                  <mat-list-option *ngFor="let user of users" [value]="user.userId" class="align-unscoped-content allow-word-wrapped-content"> {{user.userName}} </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-right: 20px">
              <button mat-button color="primary" type="submit" (click)="updateCaseAccess()">Update</button>
              <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>
